import React from "react";
import HomeContainer from "./HomeContainer";

export default () => <HomeContainer />;
